import { render, staticRenderFns } from "./PartnerSignOn.vue?vue&type=template&id=55310c30"
import script from "./PartnerSignOn.vue?vue&type=script&lang=js"
export * from "./PartnerSignOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports